var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTapeMeasureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55599 0.555542C12.0313 0.555542 14.4053 1.53887 16.1557 3.28921C17.906 5.03955 18.8893 7.41352 18.8893 9.88888H20.2227V13.8889H18.8893V19.2222H9.55599C7.08064 19.2222 4.70667 18.2389 2.95633 16.4885C1.20599 14.7382 0.222656 12.3642 0.222656 9.88888C0.222656 7.41352 1.20599 5.03955 2.95633 3.28921C4.70667 1.53887 7.08064 0.555542 9.55599 0.555542ZM9.55599 4.55554C8.1415 4.55554 6.78495 5.11744 5.78475 6.11764C4.78456 7.11783 4.22266 8.47439 4.22266 9.88888C4.22266 11.3034 4.78456 12.6599 5.78475 13.6601C6.78495 14.6603 8.1415 15.2222 9.55599 15.2222C10.9705 15.2222 12.327 14.6603 13.3272 13.6601C14.3274 12.6599 14.8893 11.3034 14.8893 9.88888C14.8893 8.47439 14.3274 7.11783 13.3272 6.11764C12.327 5.11744 10.9705 4.55554 9.55599 4.55554ZM20.2227 16.5555H26.8893V19.2222V21.8889H24.2227V19.2222H20.2227V16.5555Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapeMeasureIcon);
export default __webpack_public_path__ + "static/media/tape-measure-icon.89e7bd15dbae380e2c0ab1c0f9266275.svg";
export { ForwardRef as ReactComponent };